/**
 * mainLibs.js
 */
require(['jquery', 'bootstrap', 'es6-shim',
    'smartmenus', 'smartmenus.bootstrap',
    'EventSource', 'moment', 'devicejs',
    'bootstrap-datetimepicker',
    'bootbox', 'js-base64', 'jquery-ui', 'jquery.uniform', 'jquery-form'
], function () {

});

define("mainLibs", function(){});

